var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraduatedBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.3 496.3",
    style: {
      enableBackground: "new 0 0 496.3 496.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.2,
    y1: 492,
    x2: 248.2,
    y2: -106.0075,
    gradientTransform: "matrix(1 0 0 -1 0 498)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#006DF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01C5E9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.9,304.4l-67.7-14.5v-29.3c9.6-10.2,16.8-22.8,20.7-36.7c19.8-2.4,35.3-19.1,35.3-39.5v-64v-8v-44l16-3.8 v161.3c-9.3,3.3-16,12.1-16,22.5c0,13.2,10.8,24,24,24s24-10.8,24-24c0-10.4-6.7-19.2-16-22.5V40.3h-14.9L248.2,0l-144,42.4v20.3 l24,5.6v44v8v64c0,20.4,15.5,37.2,35.3,39.5c3.9,13.9,11.1,26.4,20.7,36.7v29.3l-67.7,14.5c-25.6,5.5-44.3,28.5-44.3,54.8v137.2h352 V359.1C424.2,332.9,405.6,309.9,379.9,304.4z M392.2,240.3c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S387.8,240.3,392.2,240.3z  M335.8,207c0.2-2.2,0.3-4.4,0.3-6.6v-38.5c9.3,3.3,16,12.1,16,22.5C352.2,194.9,345.3,203.8,335.8,207z M352.2,152.5 c-4.7-3.5-10.1-6.2-16-7.4v-24.8h16V152.5z M352.2,104.3h-96v-9.7l96-22.6V104.3z M128.3,51.9l119.8-35.2l80.4,23.7h-80.4v16h101.1 l-101,23.7L128.3,51.9z M144.2,120.3h16v24.8c-5.9,1.2-11.3,3.9-16,7.4V120.3z M144.2,184.3c0-10.4,6.7-19.2,16-22.5v38.5 c0,2.2,0.2,4.4,0.3,6.6C151,203.8,144.2,194.9,144.2,184.3z M144.2,104.3V72.1l96,22.6v9.7L144.2,104.3L144.2,104.3z M176.2,200.3 v-48h104v-16h-104v-16h144v16h-24v16h24v48c0,39.7-32.3,72-72,72S176.2,240,176.2,200.3z M200.2,302.8V274c13.8,9,30.3,14.3,48,14.3 s34.2-5.3,48-14.3v28.8l35.1,7.5l-83.1,63.9l-83.1-63.9L200.2,302.8z M408.2,480.3h-40v-112h-16v112h-96v-53.9l-8,5.9l-8-5.9v53.9 h-96v-112h-16v112h-40V359.1c0-18.7,13.3-35.2,31.6-39.1l24.8-5.3l103.6,79.7l103.6-79.7l24.8,5.3c18.3,3.9,31.6,20.4,31.6,39.1 V480.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduatedBlue);
export default __webpack_public_path__ + "static/media/graduated-blue.7d4359645b4a25437fa41729f851d99f.svg";
export { ForwardRef as ReactComponent };